import React from 'react';
import styled from 'styled-components';
import { MenuProps as AntdMenuProps } from 'antd/lib/menu';
import { Dropdown, Menu, MenuItem, Icon, Button, theme } from 'components';

interface MenuItem {
  label: string;
  value: string;
}

export interface FilterDropdownProps {
  value: string;
  menuItems: MenuItem[];
  open: boolean;
  setOpen: (open: boolean) => void;
  onChange: (value: string) => void;
  dataCy?: string;
}

const FilterDropdown = (props: FilterDropdownProps) => {
  const { value, menuItems, open, setOpen, onChange, dataCy } = props;

  const onSelect: AntdMenuProps['onClick'] = ({ key }) => {
    onChange(menuItems[Number(key)].value);
    setOpen(false);
  };

  return (
    <Dropdown
      trigger={['click']}
      open={open}
      onOpenChange={visible => setOpen(visible)}
      dropdownRender={() => (
        <Menu onClick={onSelect}>
          {menuItems.map(
            ({ label, value: itemValue }: MenuItem, idx: number) => (
              <MenuItem key={idx}>
                <IconContainer>
                  {value === itemValue && <Icon type="check" color="primary" />}
                </IconContainer>
                {label}
              </MenuItem>
            ),
          )}
        </Menu>
      )}
      overlayStyle={{
        minWidth: '12em',
      }}
    >
      <FilterDropdownButton data-cy={dataCy}>
        {menuItems.find(item => item.value === value)?.label}
        <Icon flipped={open} type="arrowDownThick" width={8} />
      </FilterDropdownButton>
    </Dropdown>
  );
};

export default FilterDropdown;

const FilterDropdownButton = styled(Button)`
  && {
    background: ${theme.gray3};
    border: 1px solid ${theme.gray5};
    font-size: 12px;
    line-height: 20px;
    padding: 0 8px;
    /* AntD sets a height that we need to override */
    height: 22px;
  }
`;

const IconContainer = styled.div`
  width: 12px;
  margin-right: 18px;
`;
